import { render, staticRenderFns } from "./PodiumCardZeta.vue?vue&type=template&id=eca86ec2&scoped=true"
import script from "./PodiumCardZeta.vue?vue&type=script&lang=js"
export * from "./PodiumCardZeta.vue?vue&type=script&lang=js"
import style0 from "./PodiumCardZeta.vue?vue&type=style&index=0&id=eca86ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca86ec2",
  null
  
)

export default component.exports